import { useEffect, useState } from "react";
import { Check, Crown } from "lucide-react";
import { api } from "@/lib/api";
import { shortDate } from "@/lib/format";
import { CardTitle } from "./ProfileCard";
import { planName } from "./AccountHero";

const price = (p) => (p.price ? `${p.price.toFixed(2).replace(/\.00$/, "")}€ / ${p.interval}` : "Free forever");

export function SubscriptionCard({ data }) {
  const [plans, setPlans] = useState(null);
  useEffect(() => { api.get("/plans").then((r) => setPlans(r.data)).catch(() => setPlans(false)); }, []);
  const current = plans ? plans.plans.find((p) => p.id === plans.current) : null;
  const status = data.subscription_status || "active";
  return (
    <section className="as-card as-subscription" data-testid="subscription-card">
      <CardTitle icon={Crown} tone="gold">Subscription</CardTitle>
      <div className="as-plan">
        <div className="as-plan-top">
          <span className="as-plan-name"><Crown size={20} /><strong data-testid="subscription-plan">{planName(data.plan, data.role)}</strong></span>
          <span className="as-status" data-testid="subscription-status">{status.replace("_", " ").toUpperCase()}</span>
        </div>
        <p data-testid="subscription-price">
          {data.role === "admin" ? "Admin account · full access" : current ? price(current) : ""}
          {data.plan_expires_at ? ` · Valid until ${shortDate(String(data.plan_expires_at).slice(0, 10))}` : ""}
        </p>
        {plans && (
          <ul>
            {(plans.is_pro ? ["Full access to every feature"] : ["Triple View, live scores and projections", "Value Scanner picks", "Every feature is open while Pro is being prepared"])
              .map((t) => <li key={t}><Check size={15} />{t}</li>)}
          </ul>
        )}
      </div>
      <button type="button" className="as-gold" disabled data-testid="subscription-manage-btn">
        {plans?.payments_enabled ? "Manage subscription" : "Upgrade — coming soon"}
      </button>
      <p className="as-muted">Online payment is not available yet.</p>
    </section>
  );
}
